// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../responsible-dealer/state/criteria';
import actions from '../../actions-list';

const updateResponsibleDealerCriteria = (state, action) =>
    Criteria.update(state, {
        [action.attribute]: {
            $set: action.value
        }
    });

const reset = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_RESPONSIBLE_DEALER_CRITERIA]: reset,
        [actions.UPDATE_RESPONSIBLE_DEALER_CRITERIA]: updateResponsibleDealerCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/responsible-dealer/reducers/criteria.js